<template>
    <div class="container">
        <vue-headful title="ABL Groupe | SIDERVAL" />
        <h2>SIDERVAL</h2>
        <section class="society--process">
            <div class="society--content">
                <div class="society--process--picture col-xs-12 col-md-5"><img :src="require('../../../assets/images/Extrudechaud_Siderval.jpg')"/></div>
                <div class="society--process--description flex-end col-xs-12 col-md-5">
                    <div class="col-xs-12">
                        <h3>Profilés spéciaux en aciers et alliages de titane filés à chaud</h3>
                        <div>
                            <div>Cette technologie très souple et économique permet de réaliser des barres pleines ou creuses selon plan client avec de faibles coûts d’outillage.</div>
                            <div>Les profilés, d'une épaisseur minimum de 5 mm, doivent s'inscrire dans un cercle de 210 mm maximum.</div>
                        </div>
                        <div>
                            <p>Poids / mètre : 1,5 à 100 kg</p>
                        </div>
                        <h3>Hot extruded steel and titanium alloys special profiles</h3>
                        <div>
                            <div>With low tooling costs, this flexible and economical technology can be used to produce complex plain or hollow bars according to customer drawing.</div>
                            <div>Profiles must have a minimum thickness of 5 mm and should be designed within a circle of 210 mm maximum.</div>
                        </div>
                        <div>
                            <p>Weight / meter : 1,5 to 100 kg</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "SidervalHotExtruded"
    }
</script>

<style scoped>

</style>